export default {
  title: 'Nebula buds AI Tawag', // "Nebula buds AI通话" 翻译为菲律宾语
  userID: 'User ID : ', // "用户ID : "
  hurryUp: 'Naghihintay ng tawag mula sa kabilang partido', // "等待对方呼叫"
  waitingCall: 'Naghihintay ng tawag mula sa kabilang partido sa pahinang ito, mangyaring huwag isara ang pahina ng maaga.', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: 'Switch ng Subtitle', // "字幕开关"
  initWait: 'Naghihintay ng inisyal na pag-setup', // "等待初始化"
  initSuccess: 'Matagumpay na na-setup, naghihintay ng tawag mula sa kabilang partido. Mangyaring huwag isara ang pahina!', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: 'Tawag nakakonekta', // "电话接通"
  callEnd: 'Tawag natapos', // "通话结束"
  careful: 'Paalala : ', // "注意 : "
  wait: 'Handa na ang bahagi ng tawag, naghihintay ng tawag mula sa kabilang partido', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: 'Arabe', // "阿拉伯语"
    da: 'Dinahik', // "丹麦语"
    de: 'Aleman', // "德语"
    en: 'Ingles', // "英语"
    es: 'Espanyol', // "西班牙语"
    fil: 'Filipino', // "菲律宾语"
    fr: 'Pranses', // "法语"
    hi: 'Indi', // "印地语"
    id: 'Indones', // "印度尼西亚语"
    it: 'Italyano', // "意大利语"
    ja: 'Hapones', // "日文"
    ko: 'Koreano', // "韩语"
    ms: 'Malay', // "马来语"
    no: 'Norwegian', // "挪威语"
    pt: 'Portuges', // "葡萄牙语"
    ru: 'Ruso', // "俄语"
    sv: 'Suedes', // "瑞典语"
    th: 'Thai', // "泰语"
    tr: 'Turko', // "土耳其语"
    vi: 'Biyetnamis', // "越南语"
    zh: 'Tsino' // "中文"
  }
}
